/**
 * Import required libraries
 */
import React from "react";
import { useTheme } from "@material-ui/core";

/**
 * Import required elements
 */
// Material-ui components
import { Tooltip, Zoom, Avatar } from "@material-ui/core";
import MenuProfile from "./MenuProfile";
import { AvatarIcon } from "../../icons";
import styles from "./styles";
import { connect } from "react-redux";

/**
 * Users Render JSX
 */
const UsersRender = props => {
  let { users, thisUser, clickProfile, buttonRef, menuIsOpen, handleClose, initiales, hasAvatar } = props;

  const theme = useTheme();
  // CSS classnames
  const classes = styles();
  return (
    <div className={classes.ConnectedUsers}>
      {users &&
        Object.keys(users).reduce((result, userUid) => {
          if (
            !users[userUid].offline &&
            thisUser.uid &&
            userUid !== thisUser.userUid
          ) {
            return [
              ...result,
              <Tooltip
                key={userUid}
                title={users[userUid].pseudo}
                TransitionComponent={Zoom}
              >
                <AvatarIcon
                  userUid={userUid}
                  iconProps={{
                    className: classes.Avatar,
                    defaultStyle: {
                      backgroundColor: users[userUid].offline
                        ? "gray"
                        : theme.palette.secondary.light
                    }
                  }}
                />
              </Tooltip>
            ];
          } else return result;
        }, [])}

      {thisUser && thisUser.userUid ? (
        <div ref={buttonRef}>
          {hasAvatar ?
            (<AvatarIcon
              iconProps={{
                className: classes.Avatar,
                "aria-owns": menuIsOpen && "menu-list-grow",
                "aria-haspopup": "true",
                onClick: clickProfile
              }}
            />)
            : (<Avatar className={classes.AvatarInitiales} onClick={clickProfile}>{initiales}</Avatar>)
          }
          <MenuProfile
            userUid={thisUser.userUid}
            menuIsOpen={menuIsOpen}
            handleClose={handleClose}
            buttonRef={buttonRef.current}
          />
        </div>
      ) : null}
    </div>
  );
};

export default connect(state => {
  let initiales = ""
  let hasAvatar = false
  if (state.list.user[state.user.userUid]) {
    let pseudo = state.list.user[state.user.userUid].pseudo
    initiales = pseudo.split(" ").map((n) => n[0]).join(".").toUpperCase();
    hasAvatar = state.list.user[state.user.userUid].avatar ? true : false
  }
  // let pseudo = initial
  return {
    initiales,
    hasAvatar
  }
})(UsersRender);